import { getDiaryContextLabel, getTrackerDisplayLabel } from "@/features/diaries/utils/displayLabels";
import { DiaryCharts } from "@patient-watch/charts";
import { diaryByIdQueryOptions } from "@/features/diaries/api";
import useExtractTracker from "@/features/entries/hooks/useExtractTracker";
import { trackerComponents as tc } from "@/features/trackers/components";
import { services as s } from "@/services";
import type { StatefulDiaryT } from "@/types/database/diaries";
import { createFileRoute } from "@tanstack/react-router";

const TrackerPreview = () => {
    const { diaryId, trackerId } = Route.useParams();
    const { diary } = Route.useLoaderData();
    const tracker = useExtractTracker(diaryId, trackerId);

    if (!tracker) {
        return (
            <>
                <h1>{getDiaryContextLabel(diary)}</h1>
                <p>Tracker not found</p>
            </>
        );
    }

    return (
        <>
            <h1>{getDiaryContextLabel(diary)}</h1>
            <h2>{getTrackerDisplayLabel(tracker)}</h2>
            <p>{s.time.formatRange(tracker.start_date, tracker.end_date)}</p>
            <p>Tracker type: {tracker.tracker_type}</p>

            <DiaryCharts diary={diary} />

            <tc.TrackerEntries tracker={tracker} />
        </>
    );
};
export const Route = createFileRoute("/preview/patient/$patientId/diary/$diaryId/tracker/$trackerId/")({
    component: TrackerPreview,
    loader: async ({ context, params }) => {
        const diary = (await context?.queryClient.ensureQueryData(
            diaryByIdQueryOptions(params.diaryId)
        )) as StatefulDiaryT;
        return { diary };
    },
});
